/** The product name as shown to the OS (window titles) and other chrome. */
export const APP_NAME = 'Flowpad';
